var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotRenewing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 15L15.9998 17L14.7998 17L14.7998 15L15.9998 15Z",
    fill: "#F9FAFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 13.5,
    r: 0.5,
    fill: "#F9FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 1.2H28.8V11H30V0H12V32H30V23H28.8V30.8H13.2V1.2Z",
    fill: "#F9FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6059 12.7578L35.4243 16.5761C35.6586 16.8105 35.6586 17.1904 35.4243 17.4247L31.6059 21.243C31.3716 21.4774 30.9917 21.4774 30.7574 21.243C30.523 21.0087 30.523 20.6288 30.7574 20.3945L33.5515 17.6004H26V16.4004H33.5515L30.7574 13.6063C30.523 13.372 30.523 12.9921 30.7574 12.7578C30.9917 12.5235 31.3716 12.5235 31.6059 12.7578Z",
    fill: "#F9FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23975 26.6621H8.30064L6.956 31.0645H3.58438L2.23975 26.6621ZM3.63924 27.698L4.3511 30.0287H6.18928L6.90115 27.698H3.63924Z",
    fill: "#F9FAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28003 25.918C5.28003 25.918 4.05286 25.7865 3.32256 24.9446C2.59226 24.1028 2.63537 22.8693 2.63537 22.8693C2.63537 22.8693 3.86254 23.0008 4.59284 23.8427C5.32315 24.6846 5.28003 25.918 5.28003 25.918Z",
    fill: "#F9FAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3059 25.918C5.3059 25.918 6.53307 25.7865 7.26338 24.9446C7.99368 24.1028 7.95057 22.8693 7.95057 22.8693C7.95057 22.8693 6.7234 23.0008 5.9931 23.8427C5.26279 24.6846 5.3059 25.918 5.3059 25.918Z",
    fill: "#F9FAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38875 23.1962C5.38875 23.1962 4.38502 23.0886 3.78769 22.4C3.19036 21.7115 3.22562 20.7026 3.22562 20.7026C3.22562 20.7026 4.22935 20.8102 4.82668 21.4987C5.42401 22.1873 5.38875 23.1962 5.38875 23.1962Z",
    fill: "#F9FAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29094 23.1962C5.29094 23.1962 6.29466 23.0886 6.892 22.4C7.48933 21.7115 7.45407 20.7026 7.45407 20.7026C7.45407 20.7026 6.45034 20.8102 5.85301 21.4987C5.25567 22.1873 5.29094 23.1962 5.29094 23.1962Z",
    fill: "#F9FAFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.342 21.1432C5.342 21.1432 5.7885 20.6634 5.7885 20.0716C5.7885 19.4798 5.342 19 5.342 19C5.342 19 4.89551 19.4798 4.89551 20.0716C4.89551 20.6634 5.342 21.1432 5.342 21.1432Z",
    fill: "#F9FAFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31L30 31V32L0 32V31Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRenewing);
export default __webpack_public_path__ + "static/media/not-renewing.21691da3.svg";
export { ForwardRef as ReactComponent };